import React from 'react';

import {globalHistory} from '@reach/router';
import {graphql, useStaticQuery} from 'gatsby';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type BannerContentQuoteProps = any;

export const BannerContentQuote: React.FC<BannerContentQuoteProps> = (props: BannerContentQuoteProps) => {
  const data = useStaticQuery(graphql`
    query BannerContentQuoteQuery {
      sanityGlobalArticleFooterBannerContentQuote {
        quoteSource
        quote
        heading
        cta {
          target
          href
          buttonText
        }
        content
      }
    }
  `);
  const globalBannerContent = data.sanityGlobalArticleFooterBannerContentQuote;
  return (
    <section className="bg-green-dark px-gutter module-spacing text-white" data-module="full-w-pull-quote">
      <div className="wrapper-default grid grid-cols-4 md:grid-cols-12 lg:gap-8 items-center">
        <div className="col-span-full lg:col-span-6 lg:ml-14">
          <div className="fill-current mb-4 lg:mb-3">
            <svg
              className="h-[18px] lg:w-25 lg:h-5 fill-current"
              viewBox="0 0 109 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M53.9167 20.1444H56.8131V0.845868H53.9167V20.1444ZM41.9652 0.845868H44.8615V20.1444H41.9652V11.9688H29.9035V20.1444H27.0062V0.845868H29.9035V9.0214H41.9679L41.9652 0.845868ZM65.8701 0.845868V20.1444H83.0046V17.1988H68.7601V11.9688H80.5514V9.02316H68.7601V3.79062H82.9956V0.845868H65.8682H65.8701ZM94.7624 3.79062V9.0214H106.554V11.967H94.7624V20.1426H91.8663V0.84409H109V3.79062H94.7624ZM17.0665 13.6877C16.4679 14.9909 15.5164 16.0936 14.3235 16.8667C13.1305 17.6398 11.7457 18.0512 10.331 18.0526C8.36112 18.0495 6.47278 17.2526 5.07984 15.8364C3.68691 14.42 2.90299 12.5 2.89992 10.4971C2.90324 8.49427 3.68722 6.57412 5.0801 5.15789C6.47299 3.74165 8.36119 2.94457 10.331 2.9412C11.7461 2.94304 13.1314 3.35497 14.3244 4.12889C15.5174 4.90281 16.4685 6.00691 17.0665 7.311L19.6915 6.06643C18.8596 4.25533 17.5372 2.72302 15.8794 1.64862C14.2216 0.57422 12.297 0.002171 10.331 0C7.59334 0.00288718 4.96847 1.10925 3.03188 3.07678C1.09528 5.04429 0.00497572 7.71266 0 10.4962C0.00284408 13.2812 1.09221 15.9513 3.02904 17.9206C4.96586 19.8899 7.59194 20.9971 10.331 21C12.297 20.9979 14.2216 20.4262 15.8794 19.3518C17.5372 18.2775 18.8596 16.7452 19.6915 14.934L17.0665 13.6877Z"
                fill="white"
              />
            </svg>
          </div>

          <h2 className="type-beta">
            {props.block?.customizeBanner ? props.block?.heading : globalBannerContent?.heading}
          </h2>
          <p className="type-p mt-3 lg:mt-4">
            {props.block?.customizeBanner ? props.block?.content : globalBannerContent?.content}
          </p>
          <div className="mt-5 lg:mt-8">
            <a
              href={props.block?.customizeBanner ? props.block?.cta[0]?.href : globalBannerContent?.cta[0]?.href}
              target={props.block?.customizeBanner ? props.block?.cta[0]?.target : globalBannerContent?.cta[0]?.target}
              className="button"
            >
              {props.block?.customizeBanner ? props.block?.cta[0]?.buttonText : globalBannerContent?.cta[0]?.buttonText}
            </a>
          </div>
        </div>

        <div className="col-span-full lg:col-start-8 lg:col-span-5 lg:pr-10 mt-12 border-l-2 border-light-gold pl-7 lg:pl-0 lg:border-none">
          <div className="relative type-zeta  before:content-['“'] before:absolute before:-left-3 lg:before:left-6 lg:border-l-2 lg:border-light-gold lg:pl-10 ">
            {props.block?.customizeBanner ? props.block?.quote : globalBannerContent?.quote}
          </div>
          <p className="lg:text-right type-sm-p mt-5 md:mt-7">
            – {props.block?.customizeBanner ? props.block?.quoteSource : globalBannerContent?.quoteSource}
          </p>
        </div>
      </div>
    </section>
  );
};
